import { MouseEvent, ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';

import styles from './ThemeLink.module.css';

export type Props = {
  className?: string;
  href?: string | null;
  inNewTab?: boolean;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  colorless?: boolean;
  disabled?: boolean;
  download?: string;
  children: ReactNode;
};
export function ThemeLink({
  className,
  href,
  inNewTab,
  onClick,
  colorless,
  disabled,
  children,
  download,
}: Props) {
  const isDisabled = disabled || (!href && !onClick);

  return onClick || !href ? (
    <a
      href={href ?? undefined}
      target={inNewTab ? '_blank' : undefined}
      rel={inNewTab ? 'noreferrer' : undefined}
      onClick={onClick}
      className={cx(className, styles.link, {
        [styles.colorless]: colorless,
        [styles.disabled]: isDisabled,
      })}
      download={download}
    >
      {children}
    </a>
  ) : (
    <Link
      to={href}
      href={href}
      target={inNewTab ? '_blank' : undefined}
      rel={inNewTab ? 'noreferrer' : undefined}
      onClick={onClick}
      className={cx(className, styles.link, {
        [styles.colorless]: colorless,
        [styles.disabled]: isDisabled,
      })}
      download={download}
      from={'/'}
    >
      {children}
    </Link>
  );
}
